<div class="search-root" [attr.data-mode]="mode" [class.open]="open">
  <!-- 搜索输入框 -->
  <div class="search-input-box" [class.focused]="open" (click)="onBoxClick()">
    <button
      *ngIf="mode === 'mobile'"
      type="button"
      class="back-btn"
      [class.active]="open"
      (click)="onBack($event)"
      aria-label="退出搜索"
    >
      ❮
    </button>
    <svg class="search-icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
    <input
      #searchInput
      type="text"
      [(ngModel)]="query"
      (focus)="onFocus()"
      (input)="onInput()"
      (keydown)="onKeydown($event)"
      placeholder="搜索商品，例如：ChatGPT、Netflix、YouTube..."
      autocomplete="off"
      aria-label="搜索商品"
      role="combobox"
      [attr.aria-expanded]="open"
    />
  </div>

  <!-- 搜索面板 -->
  <div class="search-panel" [class.active]="open" role="dialog" aria-label="搜索面板">
    <!-- 默认视图：最近搜索 + 大家都在搜 -->
    <ng-container *ngIf="!query.trim()">
      <div class="search-section" *ngIf="history.length">
        <div class="search-section-header">
          <span>最近搜索</span>
          <button type="button" class="clear-history" (click)="clearHistory()">
            全部清除
          </button>
        </div>
        <div class="history-tags">
          <div
            class="history-tag"
            *ngFor="let h of history"
            (click)="selectKeyword(h)"
          >
            <span class="history-text">{{ h }}</span>
            <span
              class="history-tag-del"
              role="button"
              [attr.aria-label]="'删除历史：' + h"
              (click)="removeHistory(h, $event)"
              >✕</span
            >
          </div>
        </div>
      </div>

      <div class="search-section">
        <div class="search-section-header"><span>大家都在搜</span></div>
        <div class="trending-list">
          <div
            class="trending-item"
            *ngFor="let t of trending; let i = index"
            (click)="selectKeyword(t.keyword)"
          >
            <div
              class="trend-rank"
              [class.gold]="i === 0"
              [class.silver]="i === 1"
              [class.bronze]="i === 2"
            >
              {{ i + 1 }}
            </div>
            <div class="trend-icon">
              <app-image *ngIf="t.icon" [fileid]="t.icon" [radius]="8"></app-image>
              <span *ngIf="!t.icon" class="icon-fallback">{{ t.fallback }}</span>
            </div>
            <div class="trend-info">
              <div class="trend-title">{{ t.title }}</div>
              <div class="trend-tag" *ngIf="t.tag">{{ t.tag }}</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- 结果视图 -->
    <ng-container *ngIf="query.trim()">
      <div class="results" role="listbox" aria-label="搜索结果" *ngIf="results.length">
        <div
          class="result-item"
          *ngFor="let r of results; let i = index"
          role="option"
          [attr.aria-selected]="i === activeIndex"
          [class.keyboard-active]="i === activeIndex"
          (click)="selectProduct(r)"
          (mouseenter)="activeIndex = i"
        >
          <div class="result-icon">
            <app-image *ngIf="r.icon" [fileid]="r.icon" [radius]="8"></app-image>
            <span *ngIf="!r.icon" class="icon-fallback">{{
              r.name.charAt(0).toUpperCase()
            }}</span>
          </div>
          <div class="result-text">
            <div class="result-title">{{ r.name }}</div>
            <div class="result-cat">在「{{ r.categoryName }}」分类中</div>
          </div>
        </div>
      </div>
      <div class="empty-state" *ngIf="!results.length">
        <strong>没有找到相关商品</strong>
        <span>换个关键词试试</span>
      </div>
    </ng-container>
  </div>
</div>
